import * as React from 'react';
import { useSelector } from 'react-redux';
import { ServicePosition } from './ServicePosition';
import { EBetPositionStatus } from '../../../../redux/reducers';
import {
  selectBetPageFullConcurrency,
  selectBetPositionStatus,
  selectIsServicePositionAvailable,
} from '../../../../selectors/betPosition';
import { selectActiveServiceId } from '../../../../selectors/publishTerms';

interface IServicePositionContainerProps {
  serviceId: string;
}

export const ServicePositionContainer: React.FC<IServicePositionContainerProps> = ({ serviceId }) => {
  const position = useSelector(selectBetPageFullConcurrency);
  const status = useSelector(selectBetPositionStatus);
  const selectedServiceId = useSelector(selectActiveServiceId);
  const isServicePositionAvailable = useSelector(selectIsServicePositionAvailable);
  const isError = status === EBetPositionStatus.fail || !position;
  const isLoading = status === EBetPositionStatus.pending;

  if (isServicePositionAvailable && serviceId === selectedServiceId) {
    return <ServicePosition position={position} isError={isError} isLoading={isLoading} />;
  }

  return null;
};
